'use client';

import { useEffect, useState } from 'react';
import { SOBYTIE_GOTOV, SOBYTIE_NASTROJKI } from '@/lib/soglasie-sobytiya';

/**
 * «Настройки cookie» в подвале: снова открывает плашку согласия, чтобы
 * человек мог передумать (16.10.2026).
 *
 * Появляется, только когда плашка на этой странице есть: её загрузчик
 * сообщает о себе событием и оставляет подпись на языке страницы. Признак
 * — «счётчик на этом адресе возможен» (`window.__ga4Vozmozhen`), а не
 * загруженный gtag.js: до «Принять» скрипта Google на странице нет, а
 * передумать человек должен мочь и после «Отказаться». Поэтому
 * на aisearch.ru, на стенде без флага отладки и на localhost ссылки нет, и
 * текста её в разметке тоже нет: сервер здесь ничего не рисует.
 */
export function NastrojkiCookie({
  className,
  kakLi = false,
}: {
  className?: string;
  /** Обернуть в `<li>`: для списков ссылок в подвале. */
  kakLi?: boolean;
}) {
  const [podpis, setPodpis] = useState<string | null>(null);

  useEffect(() => {
    const gotov = () => {
      if (window.__ga4Vozmozhen && window.__ga4Nastrojki) setPodpis(window.__ga4Nastrojki);
    };
    gotov();
    window.addEventListener(SOBYTIE_GOTOV, gotov);
    return () => {
      window.removeEventListener(SOBYTIE_GOTOV, gotov);
    };
  }, []);

  if (!podpis) return null;

  const knopka = (
    <button
      type="button"
      data-nastrojki-cookie=""
      onClick={() => {
        window.dispatchEvent(new Event(SOBYTIE_NASTROJKI));
      }}
      className={className}
    >
      {podpis}
    </button>
  );
  return kakLi ? <li>{knopka}</li> : knopka;
}
